import { isCustomShipper } from 'skladon-utils';

/** Carriers that show the order pallets tab in addition to custom shippers. */
const ORDER_PALLETS_TAB_SHIPPERS = new Set(['GEIS']);

export type OrderPalletsTabSource = {
    SHIPPER?: string | null;
    ORDER_TYPE?: string | null;
};

export const orderUsesPalletsTab = (order: OrderPalletsTabSource | null | undefined): boolean => {
    if (!order?.SHIPPER || order.ORDER_TYPE !== 'b2b') {
        return false;
    }
    return isCustomShipper(order.SHIPPER) || ORDER_PALLETS_TAB_SHIPPERS.has(order.SHIPPER.toUpperCase());
};

export const showsOrderPalletsTab = (
    order: OrderPalletsTabSource | null | undefined,
    hasListPermission: boolean
): boolean => hasListPermission && orderUsesPalletsTab(order);
